/**
 * selection — store Zustand del regulador seleccionado en el mapa.
 *
 * Un único regulador seleccionado a la vez: abre su popup, lo resalta con un
 * halo y muestra el panel de control. Centraliza lo que antes era un estado
 * `open` local por cada CabinetMarker.
 */
import { create } from 'zustand';

interface SelectionState {
  /** logicalId del regulador seleccionado, o null. */
  selectedId: number | null;
  /** Alterna la selección: si ya estaba seleccionado, lo deselecciona. */
  toggle: (id: number) => void;
  clear: () => void;
}

export const useSelection = create<SelectionState>((set) => ({
  selectedId: null,
  toggle: (id) => set(s => ({ selectedId: s.selectedId === id ? null : id })),
  clear: () => set({ selectedId: null }),
}));
